import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';

@Component({
    selector: 'not-found',
    template: `
        <div>
          <h3 service-header>{{ 'serviceUnavailable' | translate }}</h3>
        </div>`
})

export default class ServiceUnavailable {

    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/service-unavailable/service-unavailable.component.ts